import { Directive, NgModule, HostListener, Input } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { Router } from '@angular/router';

@Directive({ standalone: false,
  selector: '[docBack]'
})
export class BackDirective {

  constructor(private location: Location, private router: Router) { }
  
  @Input() docBack = '';
  @HostListener('click') onClick() {
    if (this.docBack) {
      this.router.navigate([this.docBack]);
    } else {
      this.location.back();
    }
  }

}

@NgModule({
  imports: [CommonModule],
  declarations: [BackDirective],
  exports: [BackDirective],
})
export class BackDirectiveModule {}